import { MessageCircle, Clock } from "lucide-react";
import { trackWhatsAppClick } from "@/lib/analytics";

const WhatsAppCTA = () => {
  const whatsappUrl = `https://wa.me/4917670027200?text=${encodeURIComponent("Hallo Clicks DMP, ich interessiere mich für Ihre Services!")}`;
  const handleWhatsApp = () => {
    // Track WhatsApp click using the analytics utility
    trackWhatsAppClick('cta_section');
  };
  
  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="relative bg-gradient-to-br from-primary/20 via-primary/10 to-background border border-primary/30 rounded-3xl p-12 md:p-16 overflow-hidden animate-fade-in">
          {/* Decorative glow effect */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-primary/20 rounded-full blur-3xl -z-10" />
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-primary/10 rounded-full blur-3xl -z-10" />
          
          <div className="relative z-10 text-center max-w-4xl mx-auto">
            <h2 className="text-4xl md:text-6xl font-bold mb-6">
              Schnelle <span className="text-gradient glow-text">Frage?</span>
            </h2>
            
            <p className="text-xl text-muted-foreground mb-12 leading-relaxed">
              Erhalten Sie sofortige Antworten über WhatsApp! Wir helfen Ihnen gerne bei Ihren kreativen Projekten und beantworten alle Ihre Fragen.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener"
                className="border-primary/30 bg-primary/5 text-primary backdrop-blur-xs hover:bg-primary/10 px-8 py-4 text-lg rounded-full font-semibold transition-all border flex items-center justify-center gap-2"
                onClick={handleWhatsApp}
              >
                <MessageCircle className="w-5 h-5" />
                WhatsApp Chat
              </a>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener"
                className="border-primary/30 bg-primary/5 text-primary backdrop-blur-xs hover:bg-primary/10 px-8 py-4 text-lg rounded-full font-semibold transition-all border flex items-center justify-center gap-2"
                onClick={handleWhatsApp}
              >
                <Clock className="w-5 h-5" />
                Schnelle Antwort
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsAppCTA;
